import type ServiceApi from "../../api";
import {ErrorI18n} from "../../i18n";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {ChatRequest, ChatResponse} from "../payload-types/chat";

/**
 * POST {@link RevaApi.PATH_CHAT}: schickt eine Chat-Nachricht über reva-rest an die KI (kiano) und liefert deren
 * Antwort samt `truncated`-Flag (#19490). Fehler von reva-rest kommen als Qualified-Error und laufen über den
 * regulären {@link SimpleApiInterface}-Weg; nur dessen unspezifischer Fallback `general.error.invalid` wird zu
 * `chat.error`, das zum erneuten Versuch auffordert.
 */
export class ChatApiInterface extends SimpleApiInterface<ChatResponse> {
    constructor(private readonly message: string) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_CHAT]);
    }

    protected buildPayload(): ChatRequest {
        return {message: this.message};
    }

    protected executeInternal(executor: ApiExecutor, url: string, credentials: ApiCredentials): Promise<ChatResponse> {
        return executor.fetchPOST(url, credentials, this.buildPayload());
    }

    protected override handleApiErrors(e: Error): ChatResponse {
        try {
            return super.handleApiErrors(e);
        } catch (mapped) {
            // Netzabbruch oder HTML-Antwort eines Proxys (z.B. 502 beim Neustart von reva-rest) tragen keinen
            // Qualified-Error; die Anfrage lässt sich aber meist einfach wiederholen.
            if (mapped instanceof ErrorI18n && mapped.message === "general.error.invalid") {
                throw new ErrorI18n("chat.error");
            }
            throw mapped;
        }
    }
}
